import React from 'react';
import '../styles/AboutFeaturesSection.css';

// Example SVG icons - you can replace these with imports if you have icon files
const features = [
  {
    icon: (
      <svg width="44" height="44" fill="none" viewBox="0 0 44 44">
        <circle cx="22" cy="22" r="22" fill="#1f3557" opacity="0.23"/>
        <path d="M22 10l-6 13h6l-3 11 9-15h-6l3-9z" stroke="#1f3557" strokeWidth="2" fill="none"/>
      </svg>
    ),
    title: 'Reliable Service',
    desc: 'Dependable solutions for your electrical needs, ensuring uninterrupted operation.',
  },
  {
    icon: (
      <svg width="44" height="44" fill="none" viewBox="0 0 44 44">
        <circle cx="22" cy="22" r="22" fill="#f45d75" opacity="0.15"/>
        <rect x="14" y="22" width="16" height="8" rx="2" stroke="#f45d75" strokeWidth="2" fill="none"/>
        <path d="M17 28v-2h10v2" stroke="#f45d75" strokeWidth="2" fill="none"/>
        <circle cx="22" cy="18" r="3" stroke="#f45d75" strokeWidth="2" fill="none"/>
      </svg>
    ),
    title: 'Affordable Price',
    desc: 'Quality services at competitive rates, maximizing value for your investment.',
  },
  {
    icon: (
      <svg width="44" height="44" fill="none" viewBox="0 0 44 44">
        <circle cx="22" cy="22" r="22" fill="#1f3557" opacity="0.12"/>
        <path d="M16 22h12M20 18v12M24 18v12" stroke="#1f3557" strokeWidth="2" fill="none"/>
      </svg>
    ),
    title: 'Professional Technicians',
    desc: 'Skilled experts dedicated to delivering top-notch service and satisfaction.',
  },
  {
    icon: (
      <svg width="44" height="44" fill="none" viewBox="0 0 44 44">
        <circle cx="22" cy="22" r="22" fill="#f45d75" opacity="0.15"/>
        <circle cx="22" cy="18" r="3" stroke="#f45d75" strokeWidth="2" fill="none"/>
        <circle cx="17" cy="26" r="2" stroke="#f45d75" strokeWidth="2" fill="none"/>
        <circle cx="27" cy="26" r="2" stroke="#f45d75" strokeWidth="2" fill="none"/>
      </svg>
    ),
    title: 'Worry-Free Experience',
    desc: 'Seamless process from start to finish, providing peace of mind for our customers.',
  },
];

const AboutFeaturesSection = () => (
  <div className="features-container">
    {features.map((feature, idx) => (
      <div className="feature-card" key={idx}>
        <div className="feature-icon">{feature.icon}</div>
        <div className="feature-title">{feature.title}</div>
        <div className="feature-desc">{feature.desc}</div>
      </div>
    ))}
  </div>
);

export default AboutFeaturesSection;
